const RecordStatusTypes = Object.freeze({
  IDLE: 'idle',
  RECORDING: 'recording',
  PAUSED: 'paused',
});

export default RecordStatusTypes;
